import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import { IconButtonWrapper } from 'components/ui';
import styles from './Tags.module.scss';
import { t } from 'utils';

export interface ITags extends HTMLAttributes<HTMLDivElement> {
  tags: string[];
  options: any;
  onTagRemove: (tag: string) => void;
  isFullWidthTags?: boolean;
  tagsLimitHeight?: number;
  isAllSelected?: boolean;
}

const Tags: FC<ITags> = (props) => {
  const {
    tags,
    className,
    onTagRemove = () => {},
    isFullWidthTags,
    options,
    isAllSelected,
    tagsLimitHeight,
    ...otherProps
  } = props;

  const rootClassName = classNames(styles.root, className, {
    [styles.fullWidth]: isFullWidthTags,
    [styles.limitHeight]: tagsLimitHeight,
  });
  const style = tagsLimitHeight ? { maxHeight: tagsLimitHeight } : {};

  if (!Array.isArray(tags) || !options) return null;

  return (
    <div className={rootClassName} style={style} {...otherProps}>
      {(isAllSelected ? ['all'] : tags).map((tag) => {
        const selectedOption = options.find((option: any) => option.value === tag);
        const { translationKey, label } = selectedOption || {};
        const text = translationKey ?? label;
        return (
          <div className={styles.tag} key={tag}>
            {t(text)}
            <IconButtonWrapper
              icon='times'
              className={styles.tagCloseButton}
              onClick={() => onTagRemove(tag)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Tags;
